/* eslint-disable */

import { Route as rootRouteImport } from "./routes/__root";
import { Route as ChangePasswordRouteImport } from "./routes/change-password";
import { Route as DailyReviewRouteImport } from "./routes/daily-review";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as InsightsRouteImport } from "./routes/insights";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as MurrayLabRouteImport } from "./routes/murray-lab";
import { Route as OpsRouteImport } from "./routes/ops";
import { Route as QuotesRouteImport } from "./routes/quotes";
import { Route as ScheduleRouteImport } from "./routes/schedule";
import { Route as BackupScheduleRouteImport } from "./routes/schedule.backup";
import { Route as CustomerDetailRouteImport } from "./routes/customers.$contactId";
import { Route as QuoteDetailRouteImport } from "./routes/quotes.$quoteId";
import { Route as ReviewsRouteImport } from "./routes/reviews";
import { Route as SmsRouteImport } from "./routes/sms";
import { Route as SpeedToLeadRouteImport } from "./routes/speed-to-lead";
import { Route as SettingsRouteImport } from "./routes/settings";
import { Route as SettingsAutomationsRouteImport } from "./routes/settings.automations";
import { Route as SettingsBrandRouteImport } from "./routes/settings.brand";
import { Route as SettingsRoutesRouteImport } from "./routes/settings.routes";
import { Route as SettingsRoutingRouteImport } from "./routes/settings.routing";
import { Route as SettingsTemplatesRouteImport } from "./routes/settings.templates";
import { Route as SettingsTeamRouteImport } from "./routes/settings.team";
import { Route as SettingsUsersRouteImport } from "./routes/settings.users";
import { Route as SettingsScoringRouteImport } from "./routes/settings.scoring";
import { Route as SettingsTerritoriesRouteImport } from "./routes/settings.territories";

export const routeTree = rootRouteImport.addChildren([
  LoginRouteImport,
  ChangePasswordRouteImport,
  IndexRouteImport,
  DailyReviewRouteImport,
  MurrayLabRouteImport,
  QuotesRouteImport,
  ScheduleRouteImport,
  BackupScheduleRouteImport,
  CustomerDetailRouteImport,
  QuoteDetailRouteImport,
  ReviewsRouteImport,
  SmsRouteImport,
  SpeedToLeadRouteImport,
  SettingsRouteImport,
  SettingsAutomationsRouteImport,
  SettingsBrandRouteImport,
  SettingsRoutesRouteImport,
  SettingsRoutingRouteImport,
  SettingsTemplatesRouteImport,
  SettingsTeamRouteImport,
  SettingsUsersRouteImport,
  SettingsScoringRouteImport,
  SettingsTerritoriesRouteImport,
  OpsRouteImport,
  InsightsRouteImport,
]);
